import Link from 'next/link'
import { staticFile } from '@common/utils'
import Logo from '@components/common/logo'
import BackgroundImageComponent from '@components/common/background-image'
const BackgroundImage = (): JSX.Element => (
  <>
    <BackgroundImageComponent
      image="/images/shaastra-upskill-teacher-mentoring-program/first-fold/left-shapes.svg"
      top={10}
      left={8}
      zIndex={0}
    />
  </>
)
const FirstFold = (): JSX.Element => {
  return (
    <>
      <div
        className="flex flex-col relative"
        style={{
          background:
            'linear-gradient(0.94deg, #BF3240 -9.25%, #B73252 -0.72%, #7E36D9 104.12%), #FF5A43',
        }}
      >
        <BackgroundImage />
        <Link href="/" prefetch={false}>
          <div>
            <Logo
              withText
              whiteText
              className="w-32 mt-6 ml-8 mr-2 h-8 lg:w-40 lg:h-12"
              alt="Codingal logo"
            />
          </div>
        </Link>
        <div className="mx-auto rounded-lg mt-5 lg:rounded-2xl">
          <div className="flex flex-col pb-16">
            <div className="flex flex-col mt-20 mb-10 lg:mt-0 lg:pl-20 lg:py-24">
              <h1 className="relative z-10 leading-tight text-white font-700 text-5xl lg:text-7xl lg:max-w-full text-center lg:text-left">
                Shaastra UpSkill
              </h1>
              <h2 className="text-white leading-tight font-500 text-2xl lg:mt-4 lg:text-3xl text-center lg:text-left">
                A six-session training course on <br /> Scratch Programming
              </h2>
              <div className="flex flex-col justify-center align-center my-10 lg:space-y-4 space-x-8 mx-auto lg:mx-0 lg:flex-row">
                <div className="w-20 my-2 lg:my-5 mx-auto lg:w-auto lg:mx-2">
                  <img
                    className="mx-auto"
                    src={staticFile(
                      '/images/shaastra-upskill-teacher-mentoring-program/first-fold/iitm-logo.png'
                    )}
                    alt="IIT Madras logo"
                  />
                </div>
                <div className="w-32 my-2 lg:my-5 lg:w-40 mx-2">
                  <img
                    className="mx-auto mt-4"
                    src={staticFile(
                      '/images/shaastra-upskill-teacher-mentoring-program/first-fold/shaastra-logo.png'
                    )}
                    alt="Shaastra logo"
                  />
                </div>
                <div className="w-40 my-2 lg:my-5 lg:w-auto mx-2">
                  <img
                    className="mx-auto mt-6"
                    src={staticFile(
                      '/images/shaastra-upskill-teacher-mentoring-program/first-fold/upskill-logo.png'
                    )}
                    alt="Upskill logo"
                  />
                </div>
              </div>
              <h3 className="text-white font-500 text-2xl lg:text-3xl text-center lg:text-left">
                A partner initiative with <br />{' '}
                <b>IIT-Madras &#38; Shaastra&apos;21</b>
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div
        className="absolute hidden lg:flex"
        style={{
          WebkitMaskImage:
            'radial-gradient(110% 10% at bottom, transparent 50%, #fff 50%)',
          maskImage:
            'radial-gradient(110% 5% at bottom, transparent 50%, #fff 50%)',
          background: '#FAFAFA',
          width: '100%',
          height: '70rem',
        }}
      ></div>
      <div
        className="relative flex flex-col lg:mx-40 xl:mx-10 py-12 align-center justify-center lg:rounded-lg -mt-28 bg-pink lg:bg-white"
        style={{
          boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.1)',
        }}
      >
        <h2 className="font-700 text-4xl text-grey-900 mx-auto mb-10 px-10 text-center">
          What should you expect?
        </h2>
        <div className="flex flex-col lg:flex-row">
          <div className="px-4 lg:w-1/4 align-center justify-center py-4 my-8 lg:my-0">
            <img
              className="mx-auto h-40"
              src={staticFile(
                '/images/shaastra-upskill-teacher-mentoring-program/first-fold/scratch-programming.svg'
              )}
              alt="Student learning Programming"
            />
            <h3 className="font-600 text-xl px-16 mt-6 text-center">
              An in-depth learning of Scratch programming
            </h3>
          </div>
          <div className="px-4 lg:w-1/4 align-center justify-center py-4 my-8 lg:my-0">
            <img
              className="mx-auto h-40"
              src={staticFile(
                '/images/shaastra-upskill-teacher-mentoring-program/first-fold/live-mentoring.svg'
              )}
              alt="Student attending class"
            />
            <h3 className="font-600 text-xl px-16 mt-6 text-center">
              Live mentoring sessions by experts in Scratch
            </h3>
          </div>
          <div className="px-4 lg:w-1/4 align-center justify-center py-4 my-8 lg:my-0">
            <img
              className="mx-auto h-40"
              src={staticFile(
                '/images/shaastra-upskill-teacher-mentoring-program/first-fold/curriculum.svg'
              )}
              alt="Student reading book"
            />
            <h3 className="font-600 text-xl px-12 mt-6 text-center">
              Holistic code curriculum based on STEM applications
            </h3>
          </div>
          <div className="px-4 lg:w-1/4 align-center justify-center py-4 my-8 lg:my-0">
            <img
              className="mx-auto h-40"
              src={staticFile(
                '/images/shaastra-upskill-teacher-mentoring-program/first-fold/teaching.svg'
              )}
              alt="Teacher teaching"
            />
            <h3 className="font-600 text-xl px-16 mt-6 text-center">
              Gain expertise to teach Scratch after the sessions
            </h3>
          </div>
        </div>
      </div>
    </>
  )
}
export default FirstFold
